import styled from 'styled-components';

export const AdBlockerModalContainer = styled.div`
    padding: 20px 20px;
    font-size: 14px;
    border: 1px solid ${props => props.theme.grey};

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0 15px;

        svg {
            max-width: 190px;
        }

        .warning {
            font-size: 18px;
            font-weight: ${props => props.theme.boldWeight};
            color: ${props => props.theme.error};
        }
    }

    .banner {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${props => props.theme.secondary};
        color: ${props => props.theme.white};
        padding: 20px;
        margin: 0 -20px;
        font-size: 18px;
        font-weight: ${props => props.theme.grey};
        line-height: 1;

        svg {
            width: 26px;
            height: 26px;
            margin-right: 30px;
        }
    }

    .content {
        text-align: center;
        margin: 20px 0;

        h3 {
            text-transform: initial;
            font-size: 18px;
        }

        .step {
            display: flex;
            align-items: center;
            justify-content: center;
            color: ${props => props.theme.black};
            font-size: 16px;
            font-weight: ${props => props.theme.boldWeight};
            line-height: 1;
            margin-bottom: 3px;

            svg.svg-check {
                width: 26px;
                height: 20px;
                margin-right: 5px;

                path {
                    stroke: ${props => props.theme.black};
                }
            }

            & + p {
                margin-top: 0;
            }
        }
    }

    .reload {
        text-align: center;
        margin: 30px 0;

        button {
            min-width: 280px;
        }
    }

    .pursue {
        margin: 0 40px 20px;
        text-align: center;

        label {
            text-align: left;
        }

        button {
            margin-top: 30px;
            text-transform: uppercase;

            &:disabled {
                pointer-events: visible;
                cursor: not-allowed;
            }
        }
    }

    .loader {
        margin-top: 30px;
    }

    .error {
        color: ${props => props.theme.error};
    }

    .form-submit-container {
        margin: 0;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        height: auto;
        overflow: auto;
        border: none;

        .header {
            flex-direction: column;
        }

        .banner {
            padding: 20px 10px;
        }

        .reload {
            button {
                min-width: auto;
            }
        }

        .pursue {
            margin: 0 0 30px;

            label {
                text-align: left;
            }

            button {
                font-size: 12px;
                line-height: 1.4;
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/adblocker/AdBlockerModalStyle.js